export const DEFAULT_LOAN_CONFIG = {
  annualInterestRate: 14,
  // همه مبالغ ریال (قبلاً مقیاس تومان بود)
  amountStep: 100_000_000,
  minAmount: 500_000_000,
  maxAmount: 4_000_000_000,
  installmentOptions: [24, 36, 48, 60],
  defaultInstallments: 60,
  costPerKwRial: 350_000_000,
  /** @deprecated use costPerKwRial */
  costPerKwToman: 350_000_000,
  subscriptionFee: 0,
  repaymentMethodLabel: "آنلاین",
};

export function buildLoanAmountSteps(minAmount, maxAmount, step) {
  const min = Math.max(step, minAmount);
  const max = Math.max(min, maxAmount);
  const steps = [];
  for (let value = min; value <= max; value += step) {
    steps.push(value);
  }
  return steps.length ? steps : [min];
}

export function calculateLoanTerms(principal, annualRatePercent, installmentCount) {
  const amount = Number(principal) || 0;
  const months = Number(installmentCount) || 1;
  const annualRate = Number(annualRatePercent) || 0;

  if (amount <= 0 || months <= 0) {
    return {
      monthlyInstallment: 0,
      totalInterest: 0,
      totalRepayment: 0,
    };
  }

  const monthlyRate = annualRate / 100 / 12;

  if (monthlyRate === 0) {
    const monthlyInstallment = Math.round(amount / months);
    return {
      monthlyInstallment,
      totalInterest: 0,
      totalRepayment: monthlyInstallment * months,
    };
  }

  const factor = Math.pow(1 + monthlyRate, months);
  const monthlyInstallment = Math.round(
    (amount * monthlyRate * factor) / (factor - 1)
  );
  const totalRepayment = monthlyInstallment * months;
  const totalInterest = totalRepayment - amount;

  return {
    monthlyInstallment,
    totalInterest,
    totalRepayment,
  };
}

export function estimateMaxLoanFromCapacityKw(kw, config = DEFAULT_LOAN_CONFIG) {
  const capacityKw = Number(kw);
  if (!capacityKw || capacityKw <= 0) {
    return config.maxAmount;
  }

  const raw = capacityKw * (config.costPerKwRial ?? config.costPerKwToman);
  const stepped = Math.round(raw / config.amountStep) * config.amountStep;
  return Math.min(
    config.maxAmount,
    Math.max(config.minAmount, stepped || config.minAmount)
  );
}

export function pickDefaultLoanAmount(maxAmount, config = DEFAULT_LOAN_CONFIG) {
  const capped = Math.min(maxAmount, config.maxAmount);
  const preferred = Math.round((capped * 0.875) / config.amountStep) * config.amountStep;
  return Math.max(config.minAmount, Math.min(capped, preferred || capped));
}

export function findNearestStepValue(value, steps) {
  if (!steps?.length) return value;
  return steps.reduce((best, current) =>
    Math.abs(current - value) < Math.abs(best - value) ? current : best
  );
}
